<template>
  <transition name="list">
    <div
      v-if="isOpen"
      v-loading="isLoading"
      class="InfoBox flex flex-col items-center"
    >
      <icon-account-arrow-left-outline class="text-primary-500 mb-3" />
      <div class="text-center">
        <strong class="text-primary-500 block mb-1">
          Přizvání do tlumočení
        </strong>
        <p class="text-text-light">
          {{ invitedAssistant.from_operator.first_name }} {{ invitedAssistant.from_operator.last_name }} vás zve do požadavku
        </p>
      </div>
      <div class="mt-4 flex justify-between w-full">
        <div class="flex">
          <el-tooltip
            content="Přijmout"
          >
            <el-button
              type="success"
              circle
              @click="handleAccept"
            >
              <icon-check />
            </el-button>
          </el-tooltip>
          <el-tooltip
            content="Zobrazit požadavek"
          >
            <nuxt-link
              :to="localePath(`/operator/requests/${invitedAssistant.id}/detail`)"
              class="ml-3"
            >
              <el-button
                plain
                circle
              >
                <icon-right />
              </el-button>
            </nuxt-link>
          </el-tooltip>
        </div>
        <el-tooltip
          content="Zamítnout"
        >
          <el-button
            type="danger"
            circle
            @click="handleReject"
          >
            <icon-close />
          </el-button>
        </el-tooltip>
      </div>

      <audio ref="requestForwardAudio">
        <source
          src="/sounds/request_forward.mp3"
          type="audio/mp3"
        >
      </audio>
    </div>
  </transition>
</template>

<script>
export default {
  setup() {
    const localePath = useLocalePath();
    return {
      localePath,
    };
  },
  data() {
    return {
      isOpen: false,
      isLoading: false,
    };
  },

  computed: {
    invitedAssistant() {
      return this.$store.state.operator.requests.invitedAssistant;
    },
  },

  watch: {
    invitedAssistant: {
      handler(invitedAssistant) {
        this.isOpen = !!invitedAssistant;

        this.$nextTick(async() => {
          if (this.isOpen && this.$refs.requestForwardAudio) {
            const isPlayedByExtension = await useUIStore().chromeExtensionSendMessage({ playAudio: 'requestForward' });
            if (!isPlayedByExtension) {
              this.$refs.requestForwardAudio.play().catch((error) => {
                console.warn(error);
              });
            }

            this.$store.dispatch('chat/hideChat', {
              room_id: 1,
            });
          }
        });
      },
    },
  },

  methods: {
    close() {
      this.isOpen = false;
      this.$store.commit('operator/requests/INVITE_ASSISTANT_SET', null);
    },

    async handleAccept() {
      this.isLoading = true;

      const data = {
        assistant_id: useAuthStore().user?.id,
      };

      await this.$store.dispatch('operator/requests/updateRequest', {
        id: this.invitedAssistant.id,
        data,
      });

      this.isLoading = false;

      await this.$router.push(this.$localePath(`/operator/requests/${this.invitedAssistant.id}/chat`));

      this.$store.dispatch('chat/fetchMessages', { request_id: this.invitedAssistant.id });

      this.close();
    },
    handleReject() {
      this.$socket.sendObj({
        command: 'decline_assist_request',
        request_id: this.invitedAssistant.id,
        forwarded_from: this.invitedAssistant.from_operator.id,
      });

      this.close();
    },
  },
};
</script>

<style scoped>
.InfoBox {
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 123;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 20px 50px rgb(0 0 0 / 0.1);

  padding: 24px;
}
</style>
